var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusinessTypeSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "50px",
    viewBox: "0 0 64 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Company-type",
    transform: "translate(-223.000000, -265.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-business-type-software",
    transform: "translate(223.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,0 L9,0 C7.35,0 6,1.35 6,3 L6,10 L5,10 C2.24,10 0,12.24 0,15 L0,45 C0,47.76 2.24,50 5,50 L17,50 C19.76,50 22,47.76 22,45 L22,40 L29.656,40 L27.256,48 L25,48 C24.447,48 24,48.448 24,49 C24,49.552 24.447,50 25,50 L26.656,50 L45.344,50 L47,50 C47.553,50 48,49.552 48,49 C48,48.448 47.553,48 47,48 L44.744,48 L42.344,40 L61,40 C62.65,40 64,38.65 64,37 L64,3 C64,1.35 62.65,0 61,0 Z M20,45 C20,46.65 18.65,48 17,48 L5,48 C3.35,48 2,46.65 2,45 L2,42 L20,42 L20,45 Z M20,32 L20,34 L20,38 L20,40 L2,40 L2,18 L6,18 L8,18 L20,18 L20,32 Z M20,16 L8,16 L6,16 L2,16 L2,15 C2,13.35 3.35,12 5,12 L6,12 L8,12 L17,12 C18.65,12 20,13.35 20,15 L20,16 Z M42.656,48 L29.344,48 L31.744,40 L40.256,40 L42.656,48 Z M62,18 C61.447,18 61,18.448 61,19 L61,21 C61,21.552 61.447,22 62,22 L62,32 L41.083,32 C40.53,32 40.083,32.448 40.083,33 C40.083,33.552 40.53,34 41.083,34 L62,34 L62,37 C62,37.55 61.55,38 61,38 L41.744,38 L30.256,38 L22,38 L22,34 L31.08,34 C31.64,34 32.08,33.55 32.08,33 C32.08,32.45 31.64,32 31.08,32 L22,32 L22,22 C22.553,22 23,21.552 23,21 L23,19 C23,18.448 22.553,18 22,18 L22,15 C22,12.24 19.76,10 17,10 L8,10 L8,6 L62,6 L62,18 Z M62,4 L8,4 L8,3 C8,2.45 8.45,2 9,2 L61,2 C61.55,2 62,2.45 62,3 L62,4 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.083,34 L37,34 C37.553,34 38,33.552 38,33 C38,32.448 37.553,32 37,32 L35.083,32 C34.53,32 34.083,32.448 34.083,33 C34.083,33.552 34.53,34 35.083,34 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,22 C37.553,22 38,21.552 38,21 L38,19 C38,18.448 37.553,18 37,18 C36.447,18 36,18.448 36,19 L36,21 C36,21.552 36.447,22 37,22 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,22 C27.553,22 28,21.552 28,21 L28,19 C28,18.448 27.553,18 27,18 C26.447,18 26,18.448 26,19 L26,21 C26,21.552 26.447,22 27,22 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,22 C32.553,22 33,21.552 33,21 L33,19 C33,18.448 32.553,18 32,18 C31.447,18 31,18.448 31,19 L31,21 C31,21.552 31.447,22 32,22 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,22 C42.553,22 43,21.552 43,21 L43,19 C43,18.448 42.553,18 42,18 C41.447,18 41,18.448 41,19 L41,21 C41,21.552 41.447,22 42,22 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,22 C57.553,22 58,21.552 58,21 L58,19 C58,18.448 57.553,18 57,18 C56.447,18 56,18.448 56,19 L56,21 C56,21.552 56.447,22 57,22 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,22 C47.553,22 48,21.552 48,21 L48,19 C48,18.448 47.553,18 47,18 C46.447,18 46,18.448 46,19 L46,21 C46,21.552 46.447,22 47,22 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,22 C52.553,22 53,21.552 53,21 L53,19 C53,18.448 52.553,18 52,18 C51.447,18 51,18.448 51,19 L51,21 C51,21.552 51.447,22 52,22 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 45,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,13 L10,13 C9.447,13 9,13.448 9,14 C9,14.552 9.447,15 10,15 L11,15 C11.553,15 12,14.552 12,14 C12,13.448 11.553,13 11,13 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessTypeSoftware);
export default __webpack_public_path__ + "static/media/icon-business-type-software.f5cf91f5b3a861687a27a57c69f7fad6.svg";
export { ForwardRef as ReactComponent };